import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutBottomFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutBottomFull"><Path d="M3 13V3H21V13L3 13Z" fill="currentColor"/><Path d="M3 15V21H21V15L3 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutBottomFull;
